module.exports = __webpack_public_path__ + "img/silo-icon.b3a5fe47.png";